import styled from "styled-components";

export const Container = styled.div`
  height: 93%;
`;
export const ContainerDevice = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  align-items: center;
  height: 100%;

  #deviceNotFoundTitle {
    color: #bb2a33;
    font-size: 2em;
    font-weight: 300;
  }

  .deviceNotFoundSubtitle {
    color: #0e0e0e;
    padding: 2em;
  }

  #ipStyle {
    outline: #0e0e0e;
  }
`;

export const FinishAppButton = styled.button`
  display: flex;
  align-items: center;
  background-color: #0672cb;
  font-size: 0.75em;
  color: #ffffff;
  border: none;
  height: 2.6rem;
  width: auto;
  padding: 14px;
  border-radius: 2px;
`;
